import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { FaTimes } from 'react-icons/fa'
import { ImageContainer, ImagePreview, RemoveButton } from './styles'

export default function DraggableImage ({ id, image, index, onRemove }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable ({ id })

  const style = {
    transform: CSS.Transform.toString (transform),
    transition,
    zIndex: isDragging ? 999 : 'auto'
  }

  const handleRemoveClick = (e) => {
    e.stopPropagation ()
    onRemove (index)
  }

  return (
    <ImageContainer
      ref={setNodeRef}
      style={style}
      isDragging={isDragging}
      {...attributes}
      {...listeners}
    >
      <ImagePreview 
        src={image.url || image.image_url} 
        alt={`Preview ${index}`}
        isDragging={isDragging}
      />
      <RemoveButton onClick={handleRemoveClick}>
        <FaTimes size={12} color='#FFFFFF'/>
      </RemoveButton>
    </ImageContainer>
  )
}
